import { Axios } from "../constants/api";
import { Business } from "../types/Business";
import { Supervisor } from "../types/Supervisor";

export const postSupervisor = ({
  supervisor,
  business,
}: {
  supervisor: Supervisor;
  business: Business | null;
}): Promise<Supervisor> => {
  const businessSnakeCased: { [key: string]: string } = {};
  if (business) {
    businessSnakeCased["name"] = business.companyName;
    businessSnakeCased["display_name"] = business.companyDisplayName;
    businessSnakeCased["logo"] = business.companyLogo;
    businessSnakeCased["email"] = business.email;
    businessSnakeCased["address"] = business.address;
    businessSnakeCased["registration_number"] = business.registrationNumber;
  }

  const supervisorSnakeCased = {
    first_name: supervisor.firstName,
    last_name: supervisor.lastName,
    birthdate: supervisor.dob,
    phone_number: supervisor.mobilePhone,
    email: supervisor.email,
    address: supervisor.address,
    city: supervisor.city,
    country: supervisor.country,
    postal_code: supervisor.postalCode,
    business: businessSnakeCased,
    public_key: supervisor.publicKey,
  };
  return Axios
    .post(`/supervisor/`, { ...supervisorSnakeCased })
    .then((response) => {
      const data = response.data.supervisor;
      const supervisor: Supervisor = {
        address: data.address,
        dob: data.birthdate,
        mobilePhone: data.phone_number,
        firstName: data.first_name,
        lastName: data.last_name,
        email: data.email,
        city: data.city,
        country: data.country,
        postalCode: data.postal_code,
        publicKey: data.public_key,
        id: data.id,
      };
      return supervisor;
    });
};

export const getSupervisor = (supervisorId: string): Promise<Supervisor> => {
  return Axios
    .get(`/supervisor/${supervisorId}`)
    .then((respoonse) => {
      const data = respoonse.data;
      const supervisor: Supervisor = {
        address: data.address,
        dob: data.birthdate,
        mobilePhone: data.phone_number,
        firstName: data.first_name,
        lastName: data.last_name,
        email: data.email,
        city: data.city,
        country: data.country,
        postalCode: data.postal_code,
        publicKey: data.public_key,
        id: data.id,
      };
      return Promise.resolve(supervisor);
    });
};
